export const message_portal = "0x8A8dA2124aEd9420c0B474Bc922dbAfd2dd7BBF3";

export const crypto_zombie = "0xFeb25271b5adA5115Ce489A0f83f424fB437cD09";

export const kitty_contract_address = "0x06012c8cf97BEaD5deAe237070F9587f8E7A266d";
